var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      staticClass: "form-control",
      class: {
        deactive: _vm.disabled,
      },
      attrs: { id: _vm.label + "Select", name: _vm.label + "Select" },
      domProps: { value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event.target.value)
        },
      },
    },
    [
      _vm.defaultOption
        ? _c("option", { attrs: { value: "" } }, [
            _vm._v(
              "\n\t\t\tPlease select a " +
                _vm._s(_vm.label || "option") +
                ".\n\t\t"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function (option, index) {
        return _c(
          "option",
          {
            key: index,
            domProps: { value: _vm.valueKey ? option[_vm.valueKey] : option },
          },
          [_vm._v("\n\t\t\t" + _vm._s(option[_vm.labelKey]) + "\n\t\t")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }